import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.sass']
})
export class LogoutComponent implements OnInit {
    thankYouLabel: string = "";
    loginLabel: string = "";

    constructor(private router: Router, private translationService: TranslocoService) {
        this.thankYouLabel = this.translationService.translate("Thank you for using SWFH Supervisor UI");
        this.loginLabel = this.translationService.translate("Login");
    }

    ngOnInit = (): void => {
    }

    redirectToLogin = (): void => {
        this.router.navigate([""]);

        setTimeout(() => location.reload(), 2000);
    }
}